module.exports = __webpack_public_path__ + "static/media/save-icon.a3097bc0.svg";